import { ProcessOfferItemDto } from '@/api/generated';
import {
  processOfferStatusOptionsTranslation,
  ProcessOfferStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import {
  offerOwnerPagesTranslation,
  OfferOwnerPagesTranslation,
} from '@/assets/locales/views/offers/offerOwnerPages.translation.pl.ts';
import {
  offerTemplatesTranslation,
  OfferTemplatesTranslation,
} from '@/assets/locales/views/offers/offerTemplates.translation.pl.ts';
import { OffersListSearchFormModel } from '@/views/offers/list/model/OffersListSearchForm.model.ts';

export type OffersTranslation = {
  calendar: {
    empty: string;
    monthly: string;
    next: string;
    openInClassicView: string;
    pdfPreview: string;
    prev: string;
    today: string;
    weekly: string;
  };
  createPredefined: {
    button: {
      cancel: string;
      submit: string;
    };
    field: {
      name: string;
      offerPrintId: string;
      offerType: string;
      packagePricePerPerson: string;
      predefinedOfferId: string;
    };
    title: string;
  };
  header: {
    button: {
      addPredefined: string;
    };
  };
  ownerPages: OfferOwnerPagesTranslation;
  table: {
    body: Record<
      keyof Omit<
        ProcessOfferItemDto,
        | 'availabilityRules'
        | 'calendarVisibility'
        | 'offerPrintId'
        | 'offerPrintName'
        | 'predefinedOffer'
        | 'processId'
        | 'processMultiOfferId'
        | 'processOfferId'
        | 'sentAt'
        | 'versionCorrelationId'
        | 'versionNumber'
      >,
      string
    > & {
      predefinedOffer: string;
      statusOptions: ProcessOfferStatusOptionsTranslation;
    };
    head: Record<keyof OffersListSearchFormModel, string>;
  };
  tabs: {
    calendar: string;
    list: string;
    ownerPages: string;
    templates: string;
  };
  templates: OfferTemplatesTranslation;
};

export const offersTranslation: OffersTranslation = {
  calendar: {
    empty: 'Brak predefiniowanych ofert z dostępnością.',
    monthly: 'Miesiąc',
    next: 'Następny',
    openInClassicView: 'Otwórz w widoku klasycznym',
    pdfPreview: 'Podgląd PDF',
    prev: 'Poprzedni',
    today: 'Dziś',
    weekly: 'Tydzień',
  },
  createPredefined: {
    button: {
      cancel: 'Anuluj',
      submit: 'Zapisz',
    },
    field: {
      name: 'Nazwa oferty',
      offerPrintId: 'Szablon wydruku',
      offerType: 'Typ oferty',
      packagePricePerPerson: 'Cena za osobę (PLN)',
      predefinedOfferId: 'Oferta predefiniowana (kategoria)',
    },
    title: 'Dodaj predefiniowaną ofertę',
  },
  header: {
    button: {
      addPredefined: 'Dodaj predefiniowaną ofertę',
    },
  },
  ownerPages: offerOwnerPagesTranslation,
  table: {
    body: {
      createdAt: 'Data utworzenia',
      creator: 'Autor',
      eventDateFrom: 'Start',
      eventDateTo: 'Koniec',
      name: 'Nazwa',
      noOfGuests: 'Liczba gości',
      predefinedOffer: 'Predefiniowana',
      status: 'Status',
      statusOptions: processOfferStatusOptionsTranslation,
    },
    head: {
      creatorId: 'Autor oferty',
      customerId: 'Klient',
      fullTextSearchInput: 'Wyszukaj po nazwie',
      processContactId: 'Osoba do kontaktu',
      processId: 'Proces',
      statuses: 'Statusy',
    },
  },
  tabs: {
    calendar: 'Kalendarz',
    list: 'Lista',
    ownerPages: 'Strony osobiste',
    templates: 'Szablony',
  },
  templates: offerTemplatesTranslation,
};
